module.exports = __webpack_public_path__ + "img/2_106.16032c20.png";